import apiInstance from './api';

export const authorApi = apiInstance.injectEndpoints({
  endpoints: (builder) => ({
    getAuthors: builder.query({
      query: (params) => ({
        url: '/authors',
        params,
      }),

      providesTags: ['Authors'],
    }),
    getAuthorsInfinite: builder.infiniteQuery({
      infiniteQueryOptions: {
        initialPageParam: 1,
        getNextPageParam: (lastPage, allPages, lastPageParam) =>
          lastPage['hydra:member'].length > 0 ? lastPageParam + 1 : undefined,
      },
      query({ queryArg, pageParam }) {
        const { search } = queryArg ?? {};
        return {
          url: '/authors',
          params: {
            page: pageParam,
            itemsPerPage: 20,
            ...(search && { searchKey: search }),
          },
        };
      },
      providesTags: ['AuthorsInfinite'],
    }),
    getAuthor: builder.query({
      query: (id) => `/authors/${id}`,

      providesTags: ['Author'],
    }),
    editAuthor: builder.mutation({
      query: ({ id, body }) => ({
        url: `/authors/${id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['Author'],
    }),
    addAuthor: builder.mutation({
      query: (body) => ({
        url: '/authors',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Author'],
    }),
  }),
  overrideExisting: true,
});
